const theme = {
    id: 'dark',
    bgColor: "#1E1E2C",
    cardColor: "#27293d",
    inputColor: "#2e3047",
    textColor: "#F5F6FA",
}

export default theme;